import React from 'react'

type Props = {
  children: React.ReactNode
  disabled?: boolean
}

const ClickableCard: React.FC<Props> = ({ children, disabled = false }) => {
  return (
    <div className={`rounded-lg border ${disabled ? 'cursor-default' : 'cursor-pointer bg-white shadow-md shadow-gray-100 hover:shadow-soft-green'}`}>
      {children}
    </div>
  )
}

export default ClickableCard
